import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("dp_token");
      if (!window.location.pathname.startsWith("/login")) {
        // soft redirect handled by AuthContext
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper to pull a readable message out of a FastAPI error
export function errMsg(error, fallback = "Something went wrong") {
  const d = error?.response?.data?.detail;
  if (!d) return error?.message || fallback;
  if (typeof d === "string") return d;
  if (typeof d === "object" && d.message) return d.message;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
}
